import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CommonAutoCompleteModel } from './autocompletecomponent';
import { Globals } from '../../globals';
import { AuthService } from '../../service/auth.service';
import { UserModel } from '../../model/IUser';
import { ConfigurationsService } from 'src/app/Service/configurations.service';

@Injectable({
  providedIn: 'root',
})

export class AutoCompleteService {

  private httpHeader = new HttpHeaders();
  UserTokenDetails: UserModel;
  userid: number;

  constructor(private http: HttpClient, private _global: Globals, private authService: AuthService, private configService: ConfigurationsService) {

    this.UserTokenDetails = this.authService.getLoggedInUser();
    this.userid = this.UserTokenDetails.UserId;

    this.httpHeader.append('Access-Control-Allow-Origin', '*');

  }

  // Raise validation message
  getValidationMessage(): Observable<any> {
    return this.http.get('assets/validations.json');
  }

  // Call on searched value
  search_word(param: any, methodName: any) {
    // Prepare list to pass as response if not getting any record from server
    let reqobj = [];
    let req: CommonAutoCompleteModel = new CommonAutoCompleteModel();
    req.UserId = 0;
    req.LoginId = param;
    // req.CodeDisplayName = 'NoRecord';
    reqobj.push(req);

    // Set up header.
    let httpOptions = {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Authorization': `Bearer ${this.UserTokenDetails.Token}`,
        'HideLoader': 'true'
      })
    };

    let serviceUrl = this.configService.serviceUrl('ServiceURL') + methodName + param;

    return this.http.get(serviceUrl, httpOptions).pipe(
      map((res: CommonAutoCompleteModel[]) => res && res.length > 0 ? res : reqobj),
      catchError(this._global.handleError));
  }
}
